import React from 'react'
import "./color.css"

function OrangeW() {
    var x = localStorage.getItem("percentage weight")

    return (
        <div className = "orange__background">
            {x == "NaN" ? "null": x} 
        </div>
    )
}

export default OrangeW
